<template>
    <div style="display: inline-block;">
        <Password :class="[ size ? 'p-inputtext-' + size : '' ]" v-model="text" :feedback="feedback" :toggleMask="toggleMask"
        @input="input" @blur="blur" @focus="focus" />
    </div>
</template>

<script>
import { computed } from 'vue'
import Password from 'primevue/password';

export default {
    name: 'tw-password',
    components: {
        Password
    },
    emits: {
        input: null,
        focus: null,
        blur: null
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? '' : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        const input = () => {
            context.emit('input')
        }
        const focus = () => {
            context.emit('focus')
        }
        const blur = () => {
            context.emit('blur')
        }

        return {
            text,
            input,
            focus,
            blur
        }
    },
    props: {
        modelValue: String,
        size: String,
        feedback: Boolean,
        toggleMask: Boolean
    }
}
</script>